module.exports = __webpack_public_path__ + "static/eshop5-204cdaa79c482138c1dc547bdff36153.gif";